import { AccountActionsRequest } from '@central-products/interface-account-actions';
import { RulesConfig } from '@dcf/display-rules';

export interface EventsToActionsConfig {
  default: EventsToActions;
}

export interface EventsToActions {
  [s: string]: Action | ActionFactory;
}

export interface Action {
  actionId: string;
  actionType: string;
  pathToData?: string;
  defaultData?: string | DefaultDataPerVertical | DefaultDataPerDevice;
}

export type ActionFactory = (config: ConfigArguments, payload?: AccountActionsRequest['context']) => Action;

export interface DefaultDataPerVertical {
  sports: {
    desktop: string;
    mobile: string;
  };
  gaming: {
    desktop: string;
    mobile: string;
  };
}

export interface DefaultDataPerDevice {
  desktop: string;
  mobile: string;
}

export type Language =
  | 'en-gb'
  | 'sv-se'
  | 'ru-ru'
  | 'de-de'
  | 'el-gr'
  | 'ja-jp'
  | 'fr-fr'
  | 'pl-pl'
  | 'it-it'
  | 'es-es';

export enum Jurisdiction {
  COM = 'com',
  ES = 'es',
  IT = 'it',
}

export interface AccountActionsConfig {
  regSource: string;
  isMobile: boolean;
  language?: Language;
  jurisdiction?: Jurisdiction;
  env?: string;
  dcf?: RulesConfig;
}

export interface ConfigArguments {
  language: Language;
  jurisdiction: Jurisdiction;
  regSource: string;
  isMobile: boolean;
  env?: string;
  dcf?: RulesConfig;
}
